import { render, staticRenderFns } from "./CadastroRequisicaoFornecedores.vue?vue&type=template&id=7fa146b5&"
import script from "./CadastroRequisicaoFornecedores.vue?vue&type=script&lang=js&"
export * from "./CadastroRequisicaoFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports